import React, { useCallback, useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_BASE_URL, API_ORIGIN } from '../api';
import EstimateDetailView from '../components/portal/EstimateDetailView';
import PublicBrandHeader from '../components/public/PublicBrandHeader';
import PublicBrandShell from '../components/public/PublicBrandShell';

export default function PortalEstimateDetail() {
  const { token, estimateId } = useParams();
  const [brand, setBrand] = useState(null);

  const fetchEstimate = useCallback(async () => {
    const res = await fetch(`${API_BASE_URL}public/client-portal/${token}/estimates/${estimateId}`, {
      headers: { Accept: 'application/json' },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(json?.message || `HTTP ${res.status}`);
    }
    if (json.brand) setBrand(json.brand);
    return json;
  }, [token, estimateId]);

  const postAction = useCallback(
    async (action) => {
      const res = await fetch(
        `${API_BASE_URL}public/client-portal/${token}/estimates/${estimateId}/${action}`,
        { method: 'POST', headers: { Accept: 'application/json' } }
      );
      const json = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(json?.message || `HTTP ${res.status}`);
      }
      return json;
    },
    [token, estimateId]
  );

  const pdfHref = `${API_ORIGIN}/api/public/client-portal/${token}/estimates/${estimateId}/pdf`;

  return (
    <PublicBrandShell embeddedBrand={brand}>
    <Box sx={{ maxWidth: 900, mx: 'auto', p: { xs: 2, md: 4 } }}>
      <PublicBrandHeader subtitle="Estimate" compact />
      <Button
        component={RouterLink}
        to={`/public/client/${token}`}
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 2, textTransform: 'none' }}
      >
        Back to portal
      </Button>
      <EstimateDetailView
        fetchEstimate={fetchEstimate}
        postAction={postAction}
        pdfHref={pdfHref}
        compact
      />
    </Box>
    </PublicBrandShell>
  );
}
